export default {
  // Login page
  login: "Login",
  logout: "Logout",
  forgetPassword: "Forget password",
  toRegister: "Registration",
  UIN: "UIN",
  step: "STEP",
  step1: "Enter your UIN",
  step2:
    "Введите пароль, созданный вами при регистрации. Если вы не помните пароль, выберите опцию “Забыли пароль?”",
  step3: "Нажмите на кнопку “Войти”",
  "Неверный логин и/или пароль!": "Неверный логин и/или пароль!",
  registration: "Register",
  BIN: "BIN",
  phoneNumber: "Phone number",
  back: "back",
  next: "next",
  requiredField: "Field is required!",
  enterEmail: "Enter Email",
  enterValidEmail: "Enter correct email",
  enterUINorBIN: "Enter UIN/BIN",
  chooseTaxOrgan: "Choose tax organ",
  UINLength: "IIN/BIN must be 12 symbols",
  serieLength: "Serie must be 5 symbols",
  VATLength: "VAT number must be 7 symbola",
  enterPhone: "Enter phone",
  chooseTaxType: "Choose tax type",
  onlyLatin: "Only english letters ",
  capitalizeRequired: "Не менее одной заглавной буквы",
  numberRequired: "Не менее одной цифры",
  lengthSymbols: "не менее 8 символов",
  repeatPassword: "Повторите пароль",
  passwordDontMatch: "Пароли на совпадают",
  // Profile page
  profilePage: "Profile page",
  analyticsPage: "Analytics",
  supplyPage: "Suppliies",
  discountPage: "Discount",
  addProduct: "Add Product",
  purchasesPage: "Purchases",
  "Add new product": "Add new product",
  "A network error (such as timeout, interrupted connenction or unreachable host) has occured":
    "A network error (such as timeout, interrupted connenction or unreachable host) has occured",
  salesPage: "Sales",
  Reports: "Reports",
  salesReportPage: "Sold items",
  selectStorePage: "The shops",
  cashboxPage: "Cashboxes",
  employeesPage: "Employees",
  inventoriesPage: "Inventory",
  fullname: "Full name",
  legalAddress: "Legal address",
  VAT: "VAT",
  taxOrgan: "Tax authority",
  taxType: "Tax type",
  store: "store",
  stores: "Store(s)",
  storeName: "Name of shop",
  storeAddress: "Store Address",
  // AnalyticsPage
  dailyStatistic: "Statistics for the day",
  today: "today",
  yesterday: "yesterday",
  sales: "Sales",
  // SelectStorPage
  chooseStore: "Choose a store",
  add: "Add",
  select: "Select",
  change: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  create: "Create",
  save: "Save",
  profit: "Profit",
  averageCheck: "a. check",
  order1: "orders",
  order2: "order",
  order3: "order",
  client1: "of customers",
  client2: "client",
  client3: "customer",
  total: "Total",
  numDays: "days",
  month: "month",
  numMonth: "of the month",
  other: "Other",
  allSupplies: "Total",
  barcode: "Barcode",
  supplyTitle: "Name",
  priceSale: "Price \n sale, tg",
  priceSale2: "Selling price",
  stock: "The remainder",
  stockBalance: "Balance \n in stock",
  searchWithBarcodeName: "Search by barcode or name",
  searchWithName: "Search by product name",
  pageWord: "page",
  unitsMeasuring: "unit",
  unitsMeasuringStorage: "Unit. in stock",
  discount: "A discount",
  datePurchase: "Date of purchase",
  purchasesInfo: "Purchasing Information",
  purchasePrice: "Price \n procurement, tg",
  purchaseprice: "Price procurement",
  title: "Title",
  amountProduct: "Quantity of products",
  description: "Description",
  from: "From",
  to: "To",
  discountPercent: "A discount, %",
  addDiscount: "Add share",
  link: "link",
  forOperators: "for operators",
  employe: "employe",
  totalPrice: "Total \n cost, tg",
  note: "Note ",
  purchasesSum: "Purchased \n total",
  cashboxId: "Cashbox number",
  saleId: "Sale ID",
  dateSale: "Sale date",
  quantity: "Quantity",
  price: "Price, tg",
  fiscalize: "Fiscalize",
  nameCashbox: "Box office name",
  idCashbox: "Cashbox ID",
  titleStore: "Name of store",
  addressStore: "Store Address",
  state: "Status",
  fiscal: "Fiscalization",
  cashboxInfo: "Cashbox information",
  shiftInfo: "Shift Information",
  idNumber: "An identification number",
  factoryNumber: "Factory number",
  serialNumber: "Serial number",
  cashboxDescription: "Cashbox description",
  registrationNumber: "Registration number",
  dateRegister: "Registration date",
  wayEnterDiscount: "Way to enter discounts",
  defaultIndustry: "Default industry view",
  purchaseMode: "Mode &quot;Purchase&quot;",
  markup: "Extra charge",
  serviceCenter: "Service Center",
  activationPackage: "Activation package",
  modeOperation: "Mode of operation",
  CRF: "CRF",
  confirmCode: "Confirmation code",
  switchedOn: "Switched on",
  switchedff: "Switched off",
  disconnected: "Disconnected",
  connected: "Connected",
  isAbsent: "Is absent",
  shiftNumber: "Shift number",
  shiftOpening: "Shift opening",
  cashOnHand: "Cash on hand",
  numberOfSales: "Number of sales",
  returnSales: "Return sales",
  cashSales: "Cash sales",
  cardSale: "Credit card sales",
  numberOfPurchases: "Number of purchases",
  numberOfRefunds: "Number of refunds",
  deposit: "Deposit",
  withdrawal: "Withdrawal",
  sum: "Amount",
  numberOfDocuments: "Number of documents",
  shiftClosing: "Shift shift",
  roles: "Roles",
  lastname: "Surname",
  middlename: "Middlename",
  firstname: "Firstname",
  sendPassword: "Send password",
  startInventory: "Start inventory",
  pastInventory: "Past inventory",
  dateStart: "The date of the beginning",
  dateEnd: "Expiration date ",
  show: "Show",
  edit: "Edit",
  toComplete: "To complete",
  discountToProduct: "Акция на товар",
  titleProduct: "Product Name",
  saveChanges: "Save changes",
  createNewDiscount: "Create a new stock",
  titleDiscount: "Stock name",
  product: "product",
  find: "Find",
  enterProductName: "Enter product name",
  addToDiscount: "Add to Share",
  createDiscount: "Create share",
  createPromotionalItem: "Create a promotional item",
  confirmDelete: "Confirm deletion",
  fiscalized: "Fiscalized",
  notFiscalized: "Not fiscalized",
  AddingToCategory: "Add to Category",
  AddToCategory: "Add to category",
  yes: "Yes",
  no: "No",
  enterStoreName: "Enter store name",
  selectStorage: "Choose a store",
  registerIdCashbox: "Checkout number cashbox",
  dataChange: "Data change",
  notFoundPage: "Page not found",
  "In this section you can work with your cash registers, namely":
    "In this section you can work with your cash registers, namely:",
  "Create new cash desks": "Create new cash desks",
  "Delete existing cash desks": "Delete existing cash desks",
  "Edit Title": "Edit Title",
  "Turn on / off cash desks": "Turn on / off cash desks",
  "Fiscalize cash registers": "Fiscalize cash registers",
  "In this section you can create, modify and delete stocks of your stores":
    "In this section you can create, modify and delete stocks of your stores",
  "In this section you can": "In this section you can:",
  "Add new employees to stores": "Add new employees to stores",
  "Remove employees from stores": "Remove employees from stores",
  "Edit employee access levels": "Edit employee access levels",
  "Please note that to add an employee, his / her IIN and cell phone number are required":
    "Please note that to add an employee, his / her IIN and cell phone number are required",
  "Conduct a new inventory": "Conduct a new inventory",
  "View details of previous inventories":
    "View details of previous inventories",
  "Link copied": "Link copied",
  "In the menu of a specific inventory you can":
    "In the menu of a specific inventory you can:",
  "Complete inventory at the end of the inventory":
    "Complete inventory at the end of the inventory",
  "Delete inventory": "Complete inventory at the end of the inventory",
  "Export inventory": "Export inventory",
  "In this section you can see detailed information about the owner of this Smartkassa account":
    "In this section you can see detailed information about the owner of this Smartkassa account",
  Signature: "Signature:",
  "Goods from the purchase": "Goods from the purchase",
  "In this section you can observe the information on purchases, namely":
    "In this section you can observe the information on purchases, namely:",
  "Date of purchase": "Date of purchase",
  "The cashier who procured": "The cashier who procured",
  "Total cost": "Total cost",
  "Various purchase notes": "Various purchase notes",
  "Click on the purchase you are interested in for more information":
    "Click on the purchase you are interested in for more information",
  "Password sent to the specified number":
    "Password sent to the specified number!",
  "Incorrect code entered": "Incorrect code entered",
  "Enter code": "Enter code",
  "Password recovery": "Password recovery",
  "Login/IIN": "Login/IIN",
  "Enter the code sent to your number": "Enter the code sent to your number",
  "Confirm password": "Confirm password",
  "Enter the correct code": "Enter the correct code",
  "In this section you can observe information on sales, namely":
    "In this section you can observe information on sales, namely:",
  "Date of sale": "Date of sale",
  "The cashier who conducted the sale": "The cashier who conducted the sale",
  "Various sales notes": "Various sales notes",
  "Click on the sale you are interested in for more information":
    "Click on the sale you are interested in for more information",
  "In this section you can observe detailed information about each sold product for a certain period, including":
    "In this section you can observe detailed information about each sold product for a certain period, including:",
  "Unit of measure": "Unit of measure",
  "Total cost of goods": "Total cost of goods",
  "Unit of measure in stock": "Unit of measure in stock",
  "Enter the correct password code": "Enter the correct password code",
  "Choose a store, information about which you want to receive":
    "Choose a store, information about which you want to receive",
  "Create new stores": "Create new stores",
  "Edit store names and addresses": "Edit store names and addresses",
  "Delete existing stores": "Delete existing stores",
  "Shop Creation": "Shop Creation",
  "Select Storage Shop creation step 1 info":
    "Set the name and address of the store. Please note that you specify the name of a specific point of sale (later you can change the name). The address must match the address issued during registration with the tax authority",
  "The address must match the address issued during registration with the tax authority":
    "The address must match the address issued during registration with the tax authority",
  "Cash desk creation": "Cash desk creation",
  "Creation of the first cash desk Name the cashier and select the store in which it is located":
    "Creation of the first cash desk. Name the cashier and select the store in which it is located",
  "Cashbox name": "Cashbox name",
  "Fiscalize cashbox": "Fiscalize cashbox",
  "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier":
    "Please note that if you have a physical cashier, you can Smartkassa in non-fiscal mode by printing checks through your physical cashier.",
  "Prerequisites for Fiscalization": "Prerequisites for Fiscalization:",
  "cash register must be registered with the tax authority":
    "cash register must be registered with the tax authority",
  "account on the Webkassa service (paid separately on the website wwwwebkassakz)":
    "account on the Webkassa service (paid separately on the website www.webkassa.kz)",
  "CRF account (paid separately on the website wwwoofdkz)":
    "CRF account (paid separately on the website www.oofd.kz)",
  "To Fiscalize": "To Fiscalize",
  skip: "Skip",
  "Create employee": "Create employee",
  "To register an employee, you need:": "To register an employee, you need:",
  "IIN employee and": "IIN employee and",
  "employee's cell phone number This number will receive the employee password to log into the Smartkassa system":
    "employee's cell phone number. This number will receive the employee password to log into the Smartkassa system.",
  "Submit Code": "Submit Code",
  "Password was sent to the specified number":
    "Password was sent to the specified number",
  "In this section you can observe detailed information for each of the goods you have, namely":
    "In this section you can observe detailed information for each of the goods you have, namely:",
  "Purchase price": "Purchase price",
  "The total cost of the sale of goods": "The total cost of the sale of goods",
  "Setted discount": "Setted discount",
  "Click on a product for more information":
    "Click on a product for more information",
  "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below":
    "Once you have added the stocks, add the good ones and click on the 'Add to stocks' item below",
  "Data not found": "Data not found",
  "In storage": "In storage:",
  new1: "New:",
  new2: "New:",
  new3: "New:",
  unitsMeasuringFull: "Unit of measurement:",
  purchasePrice2: "Purchase price: ",
  addUnitsMeasuring: "Add Unit",
  select2: "Select",
  selectUnitsMeasuring: "Select unit",
  purchased: "Purchased",
  value: "Value",
  clear: "Clear",
  apply: "To apply",
  "To add a filter, press Enter, then Apply":
    "To add a filter, press Enter, then Apply",
  "In this section you can observe information on purchases, sales and profits of a particular store or product":
    "In this section you can observe information on purchases, sales and profits of a particular store or product.",
  titelInventory: "Inventory name",
  redirectInventory: "Inventory Page",
  payAll: "pay all",
  payAFew: "pay a few",
  pay: "to pay",
  fyscalized: "fiscalized",
  nonFyscalized: "not fiscalized",
  extendsFor: "extended to",
  duration: "duration",
  months: "month",
  all: "all",
  drop: "drop",
  activeBy: "active until",
  fiscalization: "fiscalization",
  remainderOnStorage: "Stock balance",
  purchasePrice1: "Purchase price",
  salePrice1: "Selling price",
  addPhotoes: "Add photos",
  uploadPhotoes: "Upload photos",
  name: "Title",
  salePrice: "Selling price",
  saleprice: "Selling price",
  remainder: "The remainder",
  shortName: "unit.",
  at: "Date of purchase",
  type: "type",
  stockShortName: "",
  startedAt: "",
  finishAt: "",
  percent: "",
  amount: "",
  startDate: "",
  endDate: "",
  "Export to Excel": "Export to Excel",
  "New inventory": "New inventory",
  years: "years",
  weeks: "weeks",
  "select week": "select week",
  "select dates": "select dates",
  year: "year",
  checkNum: "Сheck number",
  AddChartToCompare: "add chart to compare",
  AddComparableChart: "add comparable chart",
  "Comparative graph for time periods of different lengths":
    "Comparative graph for time periods of different lengths",
  "Comparative Line Chart": "Comparative Line Chart",
  January: "January",
  February: "February",
  March: "March",
  April: "April",
  May: "May",
  June: "June",
  July: "July",
  August: "August",
  September: "September",
  October: "October",
  November: "November",
  December: "December",
  Monday: "Monday",
  Tuesday: "Tueasday",
  Wednesday: "Wednesday",
  Thursday: "Thursday",
  Friday: "Friday",
  Saturday: "Saturday",
  Sunday: "Sunday",
  "Trade negative": "Trade negative",
  storagePage: "Categories",
  search: "Search",
  "Select a category": "Select a category",
  showCategorySidebar: "show",
  hideCategorySidebar: "hide",
  Menu: "Menu",
  paymentPage: "Payment Page",
  nds: "VAT",
  accountInormation: "Account Information",
  companyInformation: "Company Information",
  dataOnAvailableStores: "Data on available stores",
  organization: "Organization",
  Login: "Login",
  password: "password",
  "Old password": "Input old password",
  "New password": "Input new password",
  "Repeat new password": "Repeat new password",
  "Change password": "Change password",
  "Data loading": "Data loading",
  Inventory: "Inventory",
}
